import { defineBlock } from "eddev/blocks"
import { DocumentSlider } from "@components/molecules/DocumentSlider"
import { useDocumentArchive } from "@hooks/queries"
import { DocumentCardFragment } from "../../types.graphql"
import { useEffect, useMemo, useState } from "react"
import { DocumentPanel } from "@components/molecules/DocumentPanel"

export const meta: BlockMeta = {
  title: "Curated Documents",
  category: "common",
  icon: "slides",
  keywords: ["news"],
  tags: ["root"],
  editMode: "preview",
  lazyLoad: false,
  conditions: {
    postTypes: ["page", "post"],
  },
}

export default defineBlock("news/curated-documents", (props) => {
  const [link, setLink] = useState<string>("/research-data/library")
  const [types, setTypes] = useState<string>("")
  const [topics, setTopics] = useState<string>("")
  const selection = useDocumentArchive({ count: 12, documentTypeSlug: types, documentTopicSlug: topics })

  const getLink = () => {
    const catLink = types.length > 0 ? `types=${types}` : ``
    const tagLink = topics.length > 0 ? `topics=${topics}` : ``

    setLink(`/research-data/library/?${catLink}${catLink.length > 0 ? `&` : ``}${tagLink}`)
  }

  const documents = useMemo(() => {
    if (props.selectionType) {
      if (props.byDocument) {
        return props.byDocument.map((document) => document) as DocumentCardFragment[]
      } else {
        return []
      }
    } else {
      // Taxonomy
      if (selection.data?.documents?.nodes) {
        return selection.data.documents.nodes
      } else {
        return []
      }
    }
  }, [props.selectionType, types, topics, selection])

  useEffect(() => {
    if (props.byType) {
      setTypes(props.byType.map((tax) => tax?.name).join())
    } else {
      setTypes("")
    }

    if (props.byTopic) {
      setTopics(props.byTopic.map((tax) => tax?.slug).join())
    } else {
      setTopics("")
    }
  }, [props])

  useEffect(() => {
    getLink()
  }, [types, topics])

  return (
    <>
      {documents && (
        <>
          {props.displayType ? (
            <DocumentPanel
              documents={documents as DocumentCardFragment[]}
              link={link}
              headerStyle={props.headerStyle ? true : false}
              hideLink={props.hideLibraryLink ? true : false}
            />
          ) : (
            <DocumentSlider documents={documents as DocumentCardFragment[]} />
          )}
        </>
      )}
    </>
  )
})
